/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect } from 'react';
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from 'react-beautiful-dnd';
import { UnitListing } from '../../Screens/Job/ScreenBidWorkSheetJob/utils/types';

interface DraggableProps {
  data: UnitListing[];
  items: UnitListing[];
  setItems: (e: UnitListing[]) => void;
}

function DraggableUnitTable({ data, items, setItems }: DraggableProps) {
  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const reorderedItems = Array.from(items);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);

    setItems(reorderedItems);
  };

  useEffect(() => {
    if (data?.length >= 0) {
      setItems(data);
    }
  }, [data]);

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable
        droppableId="droppable"
        direction="vertical"
        renderClone={(provided, snapshot, rubric) => {
          const item = items[rubric.source.index];

          return (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              style={{
                ...provided.draggableProps.style,
              }}
            >
              <div style={{ padding: 20, border: '1px solid #ccc', background: '#fff' }}>
                {`${item?.UnitId || 'NA'}  |  ${item?.SerialNumber || 'NA'}  |  ${item?.Model || 'NA'}  |  Tubes - ${item?.TubeCount || 0}  |  $ ${item?.Price || 0}`}
              </div>
            </div>
          );
        }}
      >
        {(droppableProvided) => (
          <div
            ref={droppableProvided.innerRef}
            {...droppableProvided.droppableProps}
            style={{
              maxHeight: '60vh',
              overflowY: 'auto',
            }}
          >
            {items.map((item, index) => (
              <Draggable key={item.UnitId} draggableId={String(item.UnitId)} index={index}>
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={provided.draggableProps.style}
                  >
                    <div style={{ padding: 20, border: '1px solid #ccc' }}>
                      {`${item?.UnitId || 'NA'}  |  ${item?.SerialNumber || 'NA'}  |  ${item?.Model || 'NA'}  |  Tubes - ${item?.TubeCount || 0}  |  $ ${item?.Price || 0}`}
                    </div>
                  </div>
                )}
              </Draggable>
            ))}

            {droppableProvided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

export default DraggableUnitTable;
